export const getLayerStrokeJoin = (layer: any) => {
  if (!layer.strokeJoin) {
    return 'MITER';
  }

  return layer.strokeJoin;
};
